export default {"src":"/_next/static/media/rafting.1e871bd4.svg","height":685,"width":685,"blurWidth":0,"blurHeight":0};